import { Button, Center, Paper, Stack, Text } from '@mantine/core';
import { IconLockExclamation } from '@tabler/icons-react';
import { useLogout } from '@api/auth';

function AccountDeactivated() {
  const { mutate: logout, isLoading: isLoggingOut } = useLogout();

  return (
    <Center mih="60vh">
      <Paper shadow="xl" p="xl" maw={480} w="100%">
        <Stack align="center" justify="center" gap="md">
          <IconLockExclamation size={56} color="var(--mantine-color-red-6)" />
          <Text fw={700} fz={22} ta="center">
            Esta cuenta está desactivada
          </Text>
          <Text c="dimmed" fz={14} ta="center">
            No es posible operar con esta cuenta. Si tienes otra cuenta disponible, puedes cambiarte
            usando el selector en el menú lateral. Si crees que esto es un error, contacta a
            soporte.
          </Text>
          <Button variant="outline" color="gray" loading={isLoggingOut} onClick={() => logout()}>
            Cerrar sesión
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
}

export default AccountDeactivated;
